// @ts-nocheck
import {useTranslation} from "react-i18next";
import {BaseButton, BaseModal} from "@/components";

const AccountValidation = ({error, onClose}) => {
  const {t} = useTranslation();

  const getErrorMessage = () => {
    if (!error?.message) {
      return t("registrationValidationModalError");
    }

    const errorMessage = error.message;

    if (errorMessage.includes("email") || errorMessage.includes("Email")) {
      return t("registrationValidationModalEmail");
    }

    if (errorMessage.includes("phone") || errorMessage.includes("Phone")) {
      return t("registrationValidationModalPhone");
    }

    if (errorMessage.includes("national_id") || errorMessage.includes("ID")) {
      return t("registrationValidationModalId");
    }

    return t("registrationValidationModalError");
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <BaseModal
      title={t("registrationAccountValidationModal")}
      open={!!error}
      onClose={handleClose}
      footer={
        <BaseButton
          variant="primary"
          onClick={handleClose}
        >
          OK
        </BaseButton>
      }
    >
      <p>{getErrorMessage()}</p>
    </BaseModal>
  );
};

export default AccountValidation;
